import { InitializeLogsProps, initializeLogs } from "./initializeLogs";
import { InitializeRumProps, initializeRum } from "./initializeRum";

export const initialize = (props: InitializeLogsProps & InitializeRumProps) => {
  // Initialize Datadog Logs
  initializeLogs(props);

  // Initialize Datadog RUM
  initializeRum(props);
};
